module.exports = __webpack_public_path__ + "static/media/wordmark.3495706e.svg";